module.exports = __webpack_public_path__ + "img/keyphrase_night.a04027af.svg";